import standardImg from "../assets/standard_tier.png";
import bronzeImg from "../assets/bronze_tier.png";
import silverImg from "../assets/silver_tier.png";
import goldImg from "../assets/gold_tier.png";
import diamondImg from "../assets/diamond_tier.png";
import platinumImg from "../assets/platinum_tier.png";

export type TierCode =
  | "standard"
  | "bronze"
  | "silver"
  | "gold"
  | "diamond"
  | "platinum";

export const tierImages: Record<TierCode, string> = {
  standard: standardImg,
  bronze: bronzeImg,
  silver: silverImg,
  gold: goldImg,
  diamond: diamondImg,
  platinum: platinumImg,
};

export const tierColors: Record<TierCode, string> = {
  standard: "#ebe5e2ff",
  bronze: "#C5713C",
  silver: "#A4A6A9",
  gold: "#E9B540",
  diamond: "#389FD7",
  platinum: "#A8AEB3",
};
